<span class="device-lock-info d-inline-flex align-items-baseline gap-1 flex-wrap">
    @if (fingerprint(); as fp) {
        <code>{{ prettifyFingerprint(fp) }}</code>
        @if (fp.browser || fp.os) {
            (
            @if (fp.browser) {
                <span class="device-lock-info__browser">{{ fp.browser }}</span>
            }
            @if (fp.os) {
                <span class="device-lock-info__os">on {{ fp.os }}</span>
            }
            )
        }
        @if (fp.isPrivateBrowser) {
            <span class="device-lock-info__incognito-marker" title="This is a private browser session.">
                <fa-icon [icon]="faIncognito"></fa-icon> Incognito Session
            </span>
        }
    } @else {
        fingerprint not available
    }
</span>
